import { appendToUrl, processInclude } from '../util/common';
import ProductHelpers from '../product/base';
import productSlider from '../components/productSlider';
import { newModalFromString, newModalWithOptions, ModalShowHide, newModalFromSelector } from '../components/modal';
import Coupon from '../components/coupon';
import { paypalUtilsInit, paypalMFRAInit } from '../checkout/paypal';
import ScalaPay from 'product/scalaPay';
import Klarna from 'product/klarna';
import ExpressCheckoutHelpers from '../checkout/expressCheckout';
import './../checkout/googlePay';
import { bonusProductModalListener, removeAllUnavailableLineItems } from './bonusProductModal';
import FindInStore from '../product/findinstore';
import BopisHelpers from '../checkout/bopisHelpers';
const summaryHelpers = require('../checkout/summary');

// Helper
var timeoutMinicart = null;

function formatDate (date) {
    return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
    date.getFullYear();
}

function removeNulls (el) {
    var price = el.find('.analytics').data('price');
    if (
        !price ||
        price == null ||
        price === 'null' ||
        price === '' ||
        price === 0 ||
        price == '0.00'
    ) {
        el.css('display', 'none');
        return true;
    }
    return false;
}

// Required to move to Wishlist from Cart (Edit Product modal)
// ---------------------------------------------------------------------------
// Bambuser soft-reload: refresh cart page content without full page reload
// so the floating miniplayer stays alive.
// ---------------------------------------------------------------------------
(function initBambuserCartRefresh () {
    var refreshing = false;

    window.addEventListener('message', function (event) {
        if (!event.data || event.data.type !== 'bambuser:refreshCart') return;
        if (refreshing) return;
        if (!$('.page[data-action="Cart-Show"]').length) return;

        refreshing = true;

        $.ajax({
            url: window.location.href,
            method: 'GET',
            dataType: 'html',
        }).then(function (html) {
            var $newDoc = $($.parseHTML(html, document, true));
            var $newCart = $newDoc.find('.cart-page');
            if ($newCart.length) {
                $('.cart-page').replaceWith($newCart);
            }
            $('.js-mainHeader-counter_minicart').text(
                $newDoc.find('.js-mainHeader-counter_minicart').text()
            );
            refreshing = false;
        }).catch(function () {
            refreshing = false;
        });
    });
})();

// ---------------------------------------------------------------------------
// Bambuser checkout teardown: on real checkout click from cart,
// remove Bambuser miniplayer wrapper from top document.
// ---------------------------------------------------------------------------
(function initBambuserCheckoutTeardown () {
    var CHECKOUT_TRIGGER_SELECTOR = '#checkout-button-secure-checkout, .checkout-btn, .js-proceed-to-checkout, .fake-checkout-btn-mobile';
    var BAMBUSER_FADEOUT_DURATION_MS = 240;
    var BAMBUSER_FADEOUT_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
    var BAMBUSER_SLIDE_X = '100px';

    function normalizePathname (url) {
        if (!url) {
            return '';
        }

        var absoluteUrl = String(url);
        if (absoluteUrl.indexOf('http') !== 0) {
            absoluteUrl = window.location.origin +
                (absoluteUrl.charAt(0) === '/' ? '' : '/') + absoluteUrl;
        }

        try {
            return new URL(absoluteUrl).pathname.toLowerCase();
        } catch (e) {
            return absoluteUrl.split('?')[0].split('#')[0].toLowerCase();
        }
    }

    function isCheckoutPath (url) {
        var path = normalizePathname(url);
        if (!path) {
            return false;
        }

        return (
            path.indexOf('/checkout') !== -1 ||
            path.indexOf('checkout-') !== -1 ||
            path.indexOf('checkoutflow') !== -1 ||
            path.indexOf('order-confirm') !== -1 ||
            path.indexOf('orderconfirmation') !== -1
        );
    }

    function getCheckoutUrlFromTarget (target) {
        if (!target || !target.closest) {
            return '';
        }

        var trigger = target.closest(CHECKOUT_TRIGGER_SELECTOR);
        if (!trigger) {
            return '';
        }

        var dataUrl = trigger.getAttribute('data-url');
        var href = trigger.getAttribute('href');

        return dataUrl || href || '';
    }

    function removeBambuserContainer () {
        var doc = document;
        try {
            if (window.top && window.top.document) {
                doc = window.top.document;
            }
        } catch (e) {
            doc = document;
        }

        var containers = doc.querySelectorAll('[data-bambuser-liveshopping-player-id]');
        for (var i = 0; i < containers.length; i++) {
            var container = containers[i];
            if (!container || !container.parentNode) {
                continue;
            }

            if (container.dataset && container.dataset.bambuserCheckoutClosing === '1') {
                continue;
            }

            if (container.dataset) {
                container.dataset.bambuserCheckoutClosing = '1';
            }

            container.style.willChange = 'transform, opacity';
            container.style.pointerEvents = 'none';
            container.style.transition = 'transform ' + BAMBUSER_FADEOUT_DURATION_MS + 'ms ' + BAMBUSER_FADEOUT_EASING + ', opacity ' + BAMBUSER_FADEOUT_DURATION_MS + 'ms ease-out';

            window.requestAnimationFrame((function (node) {
                return function () {
                    node.style.opacity = '0';
                    node.style.transform = 'translate3d(' + BAMBUSER_SLIDE_X + ', 0, 0)';
                };
            })(container));

            (function (node) {
                window.setTimeout(function () {
                    if (node) {
                        node.style.display = 'none';
                    }
                }, BAMBUSER_FADEOUT_DURATION_MS + 120);
            })(container);
        }
    }

    document.addEventListener('click', function (event) {
        var checkoutUrl = getCheckoutUrlFromTarget(event.target);
        if (!isCheckoutPath(checkoutUrl)) {
            return;
        }

        removeBambuserContainer();
    }, true);
})();

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('../product/wishlistHeart'));
    processInclude(require('../findYourSize/findYourSize'));
    ScalaPay.run();
    Klarna.loadKlarnaWidgetAndObservers();

    $('body').on('click', '#apple-pay-btn', function () {
        $('body').trigger('analytics:applepay');
        localStorage.setItem('selectedPaymentMethod', 'DW_APPLE_PAY');
    });

    $('.cc-productWrapper-productInfo-productCartDetails .cc-personalizeDetails').removeClass('cc-micro').addClass('cc-textS');
    $('.cc-productWrapper-productInfo-productCartDetails .cc-personalizeDetails_icon').removeClass('micro').addClass('small');
    $(function () {
        $('body').on('click', '.js-goToWishlist', function (e) {
            e.preventDefault();
            const headerHeight = $('.js-mainHeader-container').height();
            const wishlistPosition = $('#wishlist-slider').offset().top;
            const y = wishlistPosition - headerHeight;
            window.scrollTo({top: y, behavior: 'smooth'});
        });
    });
    $('body').on('click', '.js-linkModalFindYourSizePlp', function (e) {
        e.preventDefault();
        const htmlContent = $('.js-ModalFindYourSizePlp').html();
        // create and open confirmation modal
        const modal = newModalFromString(htmlContent, false);
        $(modal.modal).addClass('wrapperModalFindYourSizePlp');
        modal.open();
        $(modal.modalBox)
            .find('.close')
            .on('click', function (e) {
                modal.close();
            });

        $('.js-inside-close-modal').on('click', function (e) {
            e.preventDefault();
            modal.close();
        });

        $('#continue-shopping').on('click', function (e) {
            e.preventDefault();
            modal.close();
        });

        $('[data-dismiss="modalBigContent"]').on('click', function (e) {
            e.preventDefault();
            modal.close();
        });
    });
    if (!window.ApplePaySession || !window.ApplePaySession.canMakePayments() || $('#apple-pay-btn').length < 1) {
        $('.js-apple-pay-container').remove();
    }

    if (!Foundation.MediaQuery.atLeast('large')) {
        $('.js-editProductTitle').removeClass('accordion-title');
    }

    if (!Foundation.MediaQuery.atLeast('large')) {
        window.onscroll = () => {
            const addToCartCTA = $('.js-checkoutWrapper');
            const addToCartStickyBar = $('.js-checkoutStickyBar');
            const addToCartCTATop = $(addToCartCTA).offset().top;
            const addToCartCTABottom = addToCartCTATop + $(addToCartCTA).outerHeight();
            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();

            const isFooterHidden = $(window).scrollTop() + $(window).height() > $('.cc-footer').offset().top;

            if ((addToCartCTABottom > viewportTop && addToCartCTATop < viewportBottom) || isFooterHidden) {
                $(addToCartStickyBar).css({
                    bottom: '-' + $(addToCartStickyBar).outerHeight() + 'px',
                    transition: 'all 0.5s ease',
                });
            } else {
                $(addToCartStickyBar).css({bottom: '0', transition: 'all 0.5s ease'});
            }
        };
    }
});

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
export const createErrorNotification = (message) => {
    // Read sprite base url from DOM (set server-side in cart.isml). Fallback to existing static path.
    var spriteBase = ($('#sprite-url').length && $('#sprite-url').val()) || $('body').data('sprite-url');
    var errorHtml = '<div class="marketing-budge-outline border-lemon text-honey cc-cartAlert ' +
        'cc-cart-errorAndPromo-error-item message-smart-gift"> ' +

        '<i class="cc-cart-errorAndPromo-error-icon" role="presentation"> ' +
        '<svg class="no-margin medium" aria-hidden="true"> ' +
        '<use href="' + spriteBase + '"></use> ' +
        '</svg></i> <p class="cc-textS no-margin">' + message + '</p> </div>';

    $('.cart-error').append(errorHtml);
};

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
const updateAvailability = (data, uuid) => {
    var lineItem = {};
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    $('.availability-' + lineItem.UUID).empty();

    if (lineItem.availability) {
        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach(function (message) {
                messages += '<p class="line-item-attributes">' + message + '</p>';
            });
        }

        if (lineItem.availability.inStockDate) {
            messages += '<p class="line-item-attributes line-item-instock-date">' +
                lineItem.availability.inStockDate +
                '</p>';
        }
    }

    $('.availability-' + lineItem.UUID).html(messages);
};

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
const updateProductDetails = (data, uuid) => {
    var lineItem = data.cartModel.items.find(function (item) {
        return item.UUID === uuid;
    });

    if (!lineItem) {
        for (var i = 0; i < data.cartModel.items.length; i++) {
            if (data.cartModel.items[i].bonusProducts) {
                for (var j = 0; j < data.cartModel.items[i].bonusProducts.length; j++) {
                    if (data.cartModel.items[i].bonusProducts[j].UUID === uuid) {
                        lineItem = data.cartModel.items[i].bonusProducts[j];
                        break;
                    }
                }
            }
        }
    }

    if (lineItem.variationAttributes) {
        var colorAttr = lineItem.variationAttributes.find(function (attr) {
            return attr.attributeId === 'color';
        });

        if (colorAttr) {
            var colorSelector = '.color-' + uuid + ' .js-attr-display';
            var newColor = lineItem.colorFamily.toLowerCase() + ' - ' + colorAttr.displayValue.toLowerCase() + ' - ' + colorAttr.attrId.toLowerCase();
            $(colorSelector).text(newColor);
        }

        var sizeAttr = lineItem.variationAttributes.find(function (attr) {
            return attr.attributeId === 'size';
        });

        if (sizeAttr) {
            var sizeSelector = '.size-' + uuid + ' .js-attr-display';
            var newSize = sizeAttr.displayValue;
            $(sizeSelector).text(newSize);
        }

        var imageSelector = '.product-info.uuid-' + uuid + ' img.product-image';
        if (lineItem.images.small.length > 0) {
            $(imageSelector).attr('src', lineItem.images.small[0].url);
            $(imageSelector).attr('alt', lineItem.images.small[0].alt);
            $(imageSelector).attr('title', lineItem.images.small[0].title);
        }
    }

    $('.js-item-pid').text(data.newProductId.replace('~', '/'));

    var qtySelector = '.quantity[data-uuid="' + uuid + '"]';
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data('pid', data.newProductId);

    $('.remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);

    var priceSelector = '.line-item-price-' + uuid + ' .sales .value';
    $(priceSelector).text(lineItem.price.sales.formatted);
    $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

    if (lineItem.price.list) {
        var listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
        $(listPriceSelector).text(lineItem.price.list.formatted);
        $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
    }

    if (lineItem.wrappedQuantity == 0) {
        $('.js-wrapping-info-container-' + lineItem.uuid).hide();
    } else {
        $('.js-wrapping-info-container-' + lineItem.uuid).show();
        $('.js-wrapped-quantity-' + lineItem.uuid).html(lineItem.wrappedQuantity);
    }
};

/**
 * Updates details of a gift card product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
const updateGiftCardDetails = (data, uuid) => {
    var lineItem = data.cartModel.items.find(function (item) {
        return item.UUID === uuid;
    });

    var imageSelector = '.product-info.uuid-' + uuid + ' img.product-image';
    $(imageSelector).attr('src', data.item.imgUrl);

    var qtySelector = '.quantity[data-uuid="' + uuid + '"]';
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data('pid', data.newProductId);

    $('.remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);

    var priceSelector = '.line-item-price-' + uuid + ' .sales .value';
    $(priceSelector).text(lineItem.priceTotal.price);
    $(priceSelector).attr('content', lineItem.priceTotal.price);

    var listPriceSelector = '.product-info.uuid-' + uuid + ' .line-item-total-price-amount span';
    $(listPriceSelector).text(lineItem.priceTotal.price);
    $(listPriceSelector).attr('content', lineItem.priceTotal.price);
};

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
const confirmDelete = (actionUrl, productID, productName, uuid) => {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
};

const confirmRemoveProduct = (params, modal) => {
    const url = appendToUrl(params.actionUrl, {
        pid: params.productID,
        uuid: params.uuid,
        uniqueIdentifier: params.uniqueIdentifier
    });

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if (data.klarnaExpressEnabled !== undefined) {
                var klarnaIsShowing = $('.js-klarna-container').length > 0;
                if (!!data.klarnaExpressEnabled !== klarnaIsShowing) {
                    location.reload();
                    return;
                }
            }
            let outDiv = $('.uuid-' + params.uuid + ' .analytics');

            function closeNotification () {
                $('.js-add-to-wishlist-notification').off('click', '.js-close-notification');
                $('.js-add-to-wishlist-notification').remove();
            }
            if (!modal.isWishlistMove) {
                $('body').append(data.renderedTemplate);
                let offsetTop = 12;
                if (Foundation.MediaQuery.atLeast('large')) {
                    offsetTop = $('.js-mainHeader').outerHeight() + 10;
                }
                $('.js-add-to-wishlist-notification').css({
                    top: offsetTop
                });

                $('.js-add-to-wishlist-notification').on('click', '.js-close-notification', closeNotification);

                setTimeout(closeNotification, 5000);
            }

            $('body').trigger('removeItemFromCartSuccessful', { ...data, params, productData: outDiv.data(), remove_type: 'cart' });

            if ($('div.bonus-product-line-item').length > 0) {
                location.reload();
            } else {
                if (data.basket.items.length === 0) {
                    $('body').trigger('removedAllItemsFromCart', { location: 'cart' });
                    $('.cart').empty().append(`
                        <div class="grid-x">
                            <div class="cell">
                                <h1>${data.basket.resources.emptyCartMsg}</h1>
                            </div>
                        </div>`);
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);

                    if (data.basket.numItems > 0) {
                        $('.js-mainHeader-counter_minicart').empty().append(data.basket.numItems);
                        $('.js-mainHeader-minicart .popover').empty();
                        $('.js-mainHeader-minicart .popover').removeClass('show');
                    } else {
                        location.reload();
                    }
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }

                    if (params.uniqueIdentifier != undefined && params.uniqueIdentifier != null) {
                        var uniqueIdString = params.uniqueIdentifier.toString();
                        var uniqueId = uniqueIdString.substring(2, uniqueIdString.length);
                        $('.unique-identifier-' + uniqueId).remove();
                    } else {
                        $('.uuid-' + params.uuid).remove();
                    }

                    $('.js-mainHeader-counter_minicart').text('' + data.basket.items.length);

                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    $('.promos').empty().append(data.basket.totals.promocodesHtml);
                    cart.updateCartTotals(data.basket, data.loyalty);
                    cart.updateApproachingDiscounts(data.basket.approachingDiscounts);
                    cart.updateReachedDiscounts(data.basket.appliedShippingDiscounts);

                    if (data.basket.items.length === 1 && data.basket.items[0].isGiftCard) {
                        location.reload();
                    }
                    if ($('div[data-is-smart-gift-item="true"]').length > 0) {
                        location.reload();
                    }

                    if (!data.hasApproachingDiscount) {
                        location.reload();
                    }

                    if (data.basket.shipments && data.basket.shipments.length) {
                        data.basket.shipments[0].shippingMethods.forEach(function (shippingMethod) {
                            if (shippingMethod.isElectronicShipping) {
                                let lastAction = localStorage.getItem('standardProductRemoved');
                                if (lastAction) {
                                    localStorage.setItem('standardProductRemoved', '');
                                    location.reload();
                                }
                            } else {
                                localStorage.setItem('standardProductRemoved', 'yes');
                            }
                        });
                    }

                    $('body').trigger('setShippingMethodSelection', data.basket);
                    cart.validateBasket(data.basket);
                }

                modal.close();
                if (modal.isWishlistMove && this.currentlyOpenedModal) {
                    this.currentlyOpenedModal.close();
                }
                $('.card.error-message').remove();
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
            }
        }
    });
};

/**
 * replace content of modal
 * @param {Object} params - modal parameters
 * @param {boolean} isPromoCode - promo code flow otherwise is loyalty coupon flow
 */
const confirmRemovePromoCode = (params, isPromoCode = true) => {
    $.spinner().start();

    const url = appendToUrl(params.actionUrl, {
        code: params.couponCode,
        uuid: params.uuid
    });

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            $('.coupon-code-field')
                .val('')
                .removeClass('coupon-code-field--applied')
                .prop('disabled', false);
            $('.input-group-icon').removeClass('input-group-icon--applied');
            $('.js-coupon-tick').addClass('hide');
            $('.coupon-uuid-' + params.uuid).remove();
            $('.js-promocode-remove-btn').addClass('hidden');
            $('.js-promocode-add-btn').removeClass('hidden');
            $('body').trigger('cart:afterCouponApply', { code: params.couponCode, uuid: params.uuid, btnAction: 'remove' });

            cart.updateCartTotals(data);
            cart.updateApproachingDiscounts(data.approachingDiscounts);
            cart.updateReachedDiscounts(data.appliedShippingDiscounts);
            cart.validateBasket(data);
            summaryHelpers.updateTotals(data.totals);

            // Standard "promo code" or loyalty coupon
            if (isPromoCode) {
                $('.js-coupon-area').trigger('click');
                $('.loyalty-coupons-container').removeClass('disabled');
            } else {
                $('.js-coupon-area').removeClass('disabled');
                $('.js-select-loyalty-coupon').prop('checked', false).attr('checked', false);
                $('.js-loyalty-coupon-applied').addClass('hide');
                $('.js-open-coupon').removeClass('hide');
            }

            $('.js-applied-coupon-message').addClass('hide');

            if ($('.cc-productWrapper_bonus').length || $('.wrapper-bonus-product-button').length) {
                location.reload();
            }
            $.spinner().stop();
            window.location.reload();
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
                $.spinner().stop();
            }
        }
    });
};

/**
 * Move close button inside modal content box
 */
const moveModalCloseButton = () => {
    var close = document.querySelector('.tingle-modal__close');
    var modalContent = document.querySelector('.tingle-modal-box__content');
    modalContent.appendChild(close);
};

const forceShowWishlist = pid => {
    let container = $('.js-mainHeader-minicart.pdp');
    if (container.length === 0 || Foundation.MediaQuery.atLeast('medium')) {
        container = $('.js-mainHeader-minicart');
    }

    container.addClass('open');

    var url = $('.js-wishlist').data('action-url') + '?pid=' + pid;

    if (container.find('.popover.show').length === 0) {
        $.spinner().start();
        $.get(url, function (data) {
            $.spinner().stop();
            container.find('.popover')
                .empty()
                .append(data)
                .addClass('show');

            container.find('.popover').find('.closeButton').on('click touchstart', function (e) {
                e.preventDefault();
                forceHideMinicart();
            });

            let startTimer = true;
            container.on('mouseenter focusin', (e) => {
                if (timeoutMinicart != null) {
                    clearTimeout(timeoutMinicart);
                    timeoutMinicart = null;
                }
            });
            container.on('click', '.js_paypal_button', (e) => {
                startTimer = false;
                if (timeoutMinicart != null) {
                    clearTimeout(timeoutMinicart);
                    timeoutMinicart = null;
                }
            });
            container.on('mouseleave', (e) => {
                if (!startTimer) {
                    return;
                }

                if (timeoutMinicart != null) {
                    clearTimeout(timeoutMinicart);
                    timeoutMinicart = null;
                }
                timeoutMinicart = setTimeout(() => {
                    forceHideMinicart();
                }, 3000);
            });

            if (timeoutMinicart != null) {
                clearTimeout(timeoutMinicart);
                timeoutMinicart = null;
            }
            timeoutMinicart = setTimeout(() => {
                forceHideMinicart();
            }, 3000);
        });
    }
};

// const forceShowSaveForLater = pid => {
//     let container = $('.minicart.pdp');
//     if (container.length === 0 || Foundation.MediaQuery.atLeast('medium')) {
//         container = $('.minicart');
//     }

//     container.addClass('open');

//     var url = $('.wish-saveForLater').data('action-url') + '?pid=' + pid;

//     if (container.find('.popover.show').length === 0) {
//         $.spinner().start();
//         $.get(url, function (data) {
//             $.spinner().stop();
//             container.find('.popover')
//                 .empty()
//                 .append(data)
//                 .addClass('show');

//             container.find('.popover').find('.closeButton').on('click touchstart', function (e) {
//                 e.preventDefault();
//                 forceHideMinicart();
//             });

//             let startTimer = true;
//             container.on('mouseenter focusin', (e) => {
//                 if (timeoutMinicart != null) {
//                     clearTimeout(timeoutMinicart);
//                     timeoutMinicart = null;
//                 }
//             });
//             container.on('click', '.js_paypal_button', (e) => {
//                 startTimer = false;
//                 if (timeoutMinicart != null) {
//                     clearTimeout(timeoutMinicart);
//                     timeoutMinicart = null;
//                 }
//             });
//             container.on('mouseleave', (e) => {
//                 if (!startTimer) {
//                     return;
//                 }

//                 if (timeoutMinicart != null) {
//                     clearTimeout(timeoutMinicart);
//                     timeoutMinicart = null;
//                 }
//                 timeoutMinicart = setTimeout(() => {
//                     forceHideMinicart();
//                 }, 3000);
//             });

//             if (timeoutMinicart != null) {
//                 clearTimeout(timeoutMinicart);
//                 timeoutMinicart = null;
//             }
//             timeoutMinicart = setTimeout(() => {
//                 forceHideMinicart();
//             }, 3000);
//         });
//     }
// };

const forceHideMinicart = () => {
    if (timeoutMinicart != null) {
        clearTimeout(timeoutMinicart);
        timeoutMinicart = null;
    }

    if ($('.js-mainHeader-minicart .popover').hasClass('show')) {
        $('body').trigger('minicart:close');
    }
    $('.js-mainHeader-minicart .popover').removeClass('show');
    $('.js-mainHeader-minicart').removeClass('open');
};

const showAllColorsButton = () => {
    $('.js-show-view-less').on('click', function () {
        $('.js-add-view-more-background').addClass('js-show-view-more');
        $('.js-view-more-colors-button').addClass('js-show-view-more');
        $('.js-add-view-more-background').removeClass('hide').fadeIn(300);
        $('.js-view-more-colors-button').removeClass('hide').fadeIn(300);
        $('.js-show-view-less').slideUp(300);
        $('.js-hide-more-chips').slideUp(300);
    });
};

export class Cart {
    constructor () {
        this.removeAllLineItemsModal = 'removeAllLineItemsModal';
        this.removeModalID = 'removeProductModal';
        this.editModalID = 'editProductModal';
        this.removeCouponModalID = 'removeCouponModal';
        this.currentlyOpenedModal = null;
        this.coupon = new Coupon('.card.coupon-code');
        this.btnOpenSelector = '.js-open-coupon';
        this.couponModal = '#couponModal';
        this.btnLoyaltyCoupon = '.js-select-loyalty-coupon';
    }

    run () {
        this.persistentLoginListener();
        ProductHelpers.run();
        // this.removeProduct();
        this.removeNullCrossSell();
        this.removeAllLineItems();
        this.directRemoveProduct();
        this.afterRemoveFromCart();
        this.editProduct();
        this.addAnotherProduct();
        this.addToCartFromWishlist();
        this.updateAddToCart();
        this.updateAvailability();
        this.afterAttributeSelect();
        this.updateCartProductGlobal();
        this.removeBonusProduct();
        this.moveToWishlist();
        this.renderRicamo();
        this.shippingRecap();
        this.mobileOpenCheckoutCTA();
        this.openTooltip();
        BopisHelpers.run();
        if ($('meta[http-equiv=content-language]').attr('content') !== 'ru-RU') {
            paypalUtilsInit();
            paypalMFRAInit();
        }
        ExpressCheckoutHelpers.run();
        this.initCoupon();
        this.triggerExpressModal();
        bonusProductModalListener();
    }

    removeNullCrossSell () {
        $('body').on(
            'listing:einsteinloadedSuggestedProducts listing:einsteinloaded',
            function (e) {
                let $container = $('.js-em__carouselCustom');
                let index = 0;
                $container.find('.cc-emCarouselEditProd__item').each(function () {
                    if (removeNulls($(this))) {
                        index++;
                    }
                });
                if (index > 0) {
                    localStorage.setItem('suggestedProductsWithNullPrice', index);
                }
            }
        );
        $('body').on('listing:einsteinloadedSuggestedProducts', function (e) {
            let $container = $('.js-em__carouselCustom');
            let index = 0;
            $container.find('.cc-emCarouselEditProd__item').each(function () {
                if (removeNulls($(this))) {
                    index++;
                }
            });
            if (index > 0) {
                localStorage.setItem('suggestedProductsWithNullPrice', index);
            }
        });
    }

    initCoupon () {
        this.promoCode();
        this.removeLoyaltyCouponFromCart();
        this.removePromoCode();
        this.coupon.run();
        this.loyaltyCouponModal();
    }

    renderRicamo () {
        var totalCount = parseInt($('#totalCount').text());

        for (var i = 0; i < totalCount; i++) {
            $('#count-' + (i + 1)).html($('.hidden-' + (i + 1)).text());
        }
    }

    persistentLoginListener () {
        if ($('#login-popup .js-title-login-persistent').length) {
            $('.cartCustomerNotAuthenticated').trigger('click');
            $('body').on('cart:invalidatePersistentCustomerSession', function (e, data) {
                var url = $('.cartCustomerNotAuthenticated').data('url');
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    success: data => {
                        location.reload();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
        }
    }

    loyaltyCouponModal () {
        const modal = new ModalShowHide('#couponModal');

        $(document).on('click', '.js-open-coupon, .js-edit-coupon', (e) => {
            this.loyaltyCouponModalResetStatus();
            modal.show();
        });

        $(modal.modalBox).find('.js-loyaltyCoupon-close').on('click', function () {
            modal.hide();
        });

        this.loyaltyCouponConfirmSelection(modal);
        this.loyaltyCouponManageSelection();
    }

    loyaltyCouponModalResetStatus () {
        $('.js-loyaltyCoupon-item').removeClass('cc-loyaltyCoupon-item_error');
        $('.js-coupon-error').addClass('hide');
        $('.js-coupon-error-minimumOrder').addClass('hide');
    }

    loyaltyCouponConfirmSelection (modal) {
        $('#couponModal').on('click', '.js-apply-coupon', () => {
            const reqUrl = document.getElementById('addRemoveURL').value;
            const $selectedCoupons = $('.js-select-loyalty-coupon:checked');

            let arrayOfCoupons = [];
            for (let i = 0; i < $selectedCoupons.length; i++) {
                let $coupon = $selectedCoupons.eq(i);
                arrayOfCoupons.push({
                    couponCode: $coupon.data('fidelityeventid'),
                    id: $coupon.data('id'),
                    coupon: $coupon.data('coupon'),
                    pin: $coupon.data('pin'),
                    fidelityEventId: $coupon.data('fidelityeventid')
                });
            }

            const $allCoupons = $('.js-select-loyalty-coupon');
            let arrayOfCouponsToRemove = [];
            for (let i = 0; i < $allCoupons.length; i++) {
                let $coupon = $allCoupons.eq(i);
                if (!$coupon.is(':checked') && $coupon.data('uuid')) {
                    arrayOfCouponsToRemove.push($coupon.data('uuid'));
                }
            }

            // Move the FE to the correct state
            this.loyaltyCouponModalResetStatus();
            $('.js-loyalty-coupon-applied').addClass('hide');
            $('.js-coupon-area').removeClass('disabled');

            $.spinner().start();
            $.ajax({
                url: reqUrl,
                data: {
                    coupons: JSON.stringify(arrayOfCoupons),
                    couponsToRemove: JSON.stringify(arrayOfCouponsToRemove)
                },
                method: 'POST',
                dataType: 'json',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        return;
                    }

                    for (let i = 0; i < $allCoupons.length; i++) {
                        const $couponContainer = $allCoupons.eq(i);
                        const couponCode = $couponContainer.data('fidelityeventid');

                        for (let j = 0; j < data.reedemedCoupons.length; j++) {
                            if (data.reedemedCoupons[j].fidelityEventId === couponCode) {
                                let couponUUID = data.reedemedCoupons[j].uuid;

                                // Fill up UUID to manage coupon removal inside modal
                                $couponContainer.data('uuid', couponUUID).attr('data-uuid', couponUUID);

                                // Fill up data to manage coupon removal outside modal
                                $('.js-coupon-name').html($couponContainer.data('couponName'));
                                $('.js-remove-loyalty-coupon').data('code', data.reedemedCoupons[j].couponCode);
                                $('.js-remove-loyalty-coupon').data('uuid', couponUUID);

                                // Show loyalty coupon area
                                $('.js-loyalty-coupon-applied').removeClass('hide');

                                // Hide loyalty add area
                                $('.js-open-coupon').addClass('hide');

                                // Block promo code area
                                if ($('.js-coupon-area').parent().hasClass('active')) {
                                    $('.js-coupon-area').trigger('click');
                                }
                                $('.js-coupon-area').addClass('disabled');

                                // Show checkout message of applied coupons
                                if (data.cart.coupon) {
                                    $('.js-applied-coupon-amount').text(data.cart.coupon.message.loyaltyCouponAmount);
                                    $('.js-applied-coupon-total').text(data.cart.coupon.message.totalOrder);
                                    $('.js-applied-coupon-message').removeClass('hide');
                                }
                                break;
                            }
                        }
                    }

                    let errorMinimumOrder = false;
                    if (!data.hasApproachingDiscount) {
                        errorMinimumOrder = true;
                        const couponValueMsg = data.couponValueMsg;
                        $('.js-threshold-not-reached').html(couponValueMsg);
                        $('.js-loyaltyCoupon-item').addClass('cc-loyaltyCoupon-item_error');
                        $('.js-coupon-error-minimumOrder').removeClass('hide');
                        $('.js-remove-coupon').trigger('click');
                    }

                    let errorFound = false;
                    for (let i = 0; i < data.notRedimable.length; i++) {
                        errorFound = true;
                        const couponCode = data.notRedimable[i];
                        const $couponContainer = $(`.js-select-loyalty-coupon[data-fidelityeventid="${couponCode}"]`);
                        $couponContainer.prop('checked', false).closest('.js-loyaltyCoupon-item').addClass('cc-loyaltyCoupon-item_error');
                        $('.js-coupon-error').removeClass('hide');
                    }

                    // Update the FE with the new totals
                    cart.updateCartTotals(data.cart);
                    cart.updateApproachingDiscounts(data.cart.approachingDiscounts);
                    cart.validateBasket(data.cart);
                    summaryHelpers.updateTotals(data.cart.totals);

                    if (!errorFound && !errorMinimumOrder) {
                        if (arrayOfCoupons.length > 0) {
                            $('body').trigger('loyaltyCoupon:apply', { 'couponCode': arrayOfCoupons[0].coupon });
                        }
                        modal.hide();
                        location.reload();
                    }
                },
                error: function (data) {
                    $('.js-select-loyalty-coupon:checked').parents('.js-loyaltyCoupon-item').addClass('cc-loyaltyCoupon-item_error');
                    $('.js-coupon-error').removeClass('hide');
                    $.spinner().stop();
                }
            });
        });
    }

    loyaltyCouponManageSelection () {
        $('#couponModal').on('click', this.btnLoyaltyCoupon, evt => {
            if ($(evt.currentTarget).is(':checked')) {
                addLoyaltyCoupon(evt);
            } else {
                removeLoyaltyCoupon(evt);
            }
        });

        const removeLoyaltyCoupon = () => {
            let removedCouponCount = $('.js-select-loyalty-coupon:not([data-uuid=""]):not(:checked)').length;

            if ($('.js-select-loyalty-coupon:checked').length === 0 && removedCouponCount === 0) {
                $('.js-apply-coupon').prop('disabled', true);
            }
            if (removedCouponCount > 0) {
                $('.js-apply-coupon').prop('disabled', false);
            }
        };

        // De-select other coupons and enables CTA
        const addLoyaltyCoupon = (evt) => {
            const $currentSelection = $(evt.currentTarget);
            $('.js-select-loyalty-coupon:checked').not($currentSelection).prop('checked', false);
            $('.js-apply-coupon').prop('disabled', false);
        };
    }

    moveToWishlist () {
        $('.js-move-to-wishlist').on('click', e => {
            require('../product/wishlistHeart').moveToWishlistHelper(e).then(function (rsp) {
                if (rsp.error === true) {
                    $.spinner().stop();
                } else {
                    const pid = $(e.currentTarget).data('pid');
                    const actionUrl = $(`.remove-product[data-pid="${pid}"]`).data('action');
                    const uuid = $(`.remove-product[data-pid="${pid}"]`).data('uuid');

                    $('body').trigger('wishlist:add', { sku: pid, sender: 'cart' });

                    const data = {
                        actionUrl: actionUrl,
                        productID: pid,
                        uuid: uuid
                    };

                    confirmRemoveProduct(data, {close: function () {}, isWishlistMove: true});
                    forceShowWishlist(pid);
                }
            });
        });
        $('.js-save-for-later').on('click', e => {
            require('../product/wishlistHeart').moveToWishlistHelperSaveForLater(e).then(function (rsp) {
                if (rsp.error === true) {
                    createErrorNotification(rsp.msg);
                    $.spinner().stop();
                } else {
                    const pid = $(e.currentTarget).data('pid');
                    const actionUrl = $(`.remove-product[data-pid="${pid}"]`).data('action');
                    const uuid = $(`.remove-product[data-pid="${pid}"]`).data('uuid');

                    const data = {
                        actionUrl: actionUrl,
                        productID: pid,
                        uuid: uuid
                    };

                    confirmRemoveProduct(data, {close: function () {}, isWishlistMove: false});
                }
            });
        });
        $('.js-move-to-wishlist-saveForLater').on('click', e => {
            require('../product/wishlistHeart').moveToWishlistHelper(e).then(function (rsp) {
                if (rsp.error === true) {
                    $.spinner().stop();
                } else {
                    const pid = $(e.currentTarget).data('pid');
                    $('body').trigger('wishlist:add', { sku: pid, sender: 'cart' });

                    var form = {
                        pid: pid,
                        quantity: 1
                    };

                    forceShowWishlist(pid);
                    handleRemoveSaveForlater(form);
                }
            });
        });
        const handleRemoveSaveForlater = response => {
            var url = $('.removeSaveForLater').val();
            $.ajax({
                url: url,
                method: 'POST',
                data: response,
                success: function (html) {
                    location.reload();
                },
                error: function () {
                }
            });
        };
    }

    removeProduct () {
        $('body').on('click', '.remove-product', e => {
            e.preventDefault();

            // product info
            const data = {
                actionUrl: $(e.currentTarget).data('action'),
                productID: $(e.currentTarget).data('pid'),
                uuid: $(e.currentTarget).data('uuid'),
                uniqueIdentifier: $(e.currentTarget).data('uniqueidentifier')
            };

            // prepare modal
            const productName = e.currentTarget.dataset.name;
            document.getElementById(this.removeModalID).querySelector('.product-to-remove').innerHTML = productName;
            const htmlContent = document.getElementById('removeProductModal').innerHTML;

            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['cart-remove-product', 'cc-removeProductModal']);
            moveModalCloseButton();
            modal.open();

            $(modal.modalBox).on('click', '.close', function () {
                modal.close();
                modal.destroy();
            });
            modal.open();

            if (data.uniqueIdentifier != null) {
                $('.confirm-delete-button').siblings('.js-move-to-wishlist').first().hide();
                $('.confirm-delete-button').css('margin', '0 auto');
                $('.modal-body.delete-confirmation-body').hide();
            } else {
                $('.modal-body.delete-confirmation-body').show();
            }

            if (e.currentTarget.dataset.isgiftcard) {
                $(modal.modalBox).find('.js-move-to-wishlist').addClass('hide');
            }

            $(modal.modalBox).find('.js-move-to-wishlist').data('pid', data.productID);
            $(modal.modalBox).on('click', '.js-move-to-wishlist', e => {
                require('../product/wishlistHeart').moveToWishlistHelper(e).then(function (rsp) {
                    if (rsp.error === true) {
                        $.spinner().stop();
                    } else {
                        const pid = $(e.currentTarget).data('pid');
                        const actionUrl = $(`.remove-product[data-pid="${pid}"]`).data('action');
                        const uuid = $(`.remove-product[data-pid="${pid}"]`).data('uuid');

                        $('body').trigger('wishlist:add', { sku: pid, sender: 'cart' });

                        const data = {
                            actionUrl: actionUrl,
                            productID: pid,
                            uuid: uuid
                        };
                        confirmRemoveProduct(data, {close: function () {}, isWishlistMove: true});
                        modal.close();
                        forceShowWishlist(pid);
                    }
                });
            });

            $(modal.modalBox).on('click', '.cart-delete-confirmation-btn', function () {
                confirmRemoveProduct(data, modal);
            });

            this.currentlyOpenedModal = modal;
        });
    }

    directRemoveProduct () {
        $('body').on('click', '.js-direct-remove-product', e => {
            e.preventDefault();

            // product info
            const data = {
                actionUrl: $(e.currentTarget).data('action'),
                productID: $(e.currentTarget).data('pid'),
                uuid: $(e.currentTarget).data('uuid'),
                uniqueIdentifier: $(e.currentTarget).data('uniqueidentifier')
            };

            confirmRemoveProduct(data, {close: function () {}, isWishlistMove: false});
        });
    }

    removeAllLineItems () {
        $('body').on('click', '.js-remove-all-line-items', e => {
            e.preventDefault();

            // prepare modal content
            const htmlContent = document.getElementById(this.removeAllLineItemsModal).innerHTML;

            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['cc-removeAllModal', 'cc-removeProductModal']);
            moveModalCloseButton();
            modal.open();

            // prepare handler - close modal from a close icon as well as from a cancel button.
            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });

            const url = $(e.currentTarget).data('action');
            // prepare handler - confirm button
            $(modal.modalBox).on('click', '#remove-all-line-items-confirm', function () {
                $.spinner().start();

                $.ajax({
                    url: url,
                    type: 'get',
                    success: function () {
                        $('body').trigger('removedAllItemsFromCart', { location: 'cart' });
                        $.spinner().stop();
                        modal.close();
                        location.reload();
                    },
                    error: function (data) {
                        $.spinner().stop();
                        $(modal.modalBoxContent).find('.modal-body')
                            .hide()
                            .html('<p>' + data.responseJSON.message + '</p>')
                            .fadeIn();
                    }
                });
            });

            this.currentlyOpenedModal = modal;
        });
    }

    afterRemoveFromCart () {
        $('body').on('afterRemoveFromCart', function (e, data) {
            e.preventDefault();
            confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
        });
    }

    addToCartFromWishlist () {
        $('body').on('click', '.js-wishlist-add-to-cart', function (e) {
            e.preventDefault();
            var pid;
            var addToCartUrl;
            var $target = $(e.currentTarget);

            $('body').trigger('product:beforeAddToCart', this);

            pid = $(this).data('pid');
            addToCartUrl = $(this).data('url');
            var promoId = $(this).data('promotion-id') || false;
            var $productContainer = $(this).closest('.wishlist-product-card');

            var form = {
                pid: pid,
                quantity: 1,
                promoId: promoId
            };

            if ($(this).data('option')) {
                form.options = JSON.stringify($(this).data('option'));
            }
            $.spinner().start();

            $(this).trigger('updateAddToCartFormData', form);
            if ($('.js-complete-your-promo').length > 0) {
                $('.js-complete-the-promo-status').val($('.js-complete-the-promo-status').val() - form.quantity);
                form.completePromoItems = $('.js-complete-the-promo-status').val();
            }

            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        if (data.completePromoItemsLabel && data.completePromoItemsLabel !== '' && $('.js-completeYourPromo-header_remaining').length > 0) {
                            $('.js-completeYourPromo-header_remaining').html(data.completePromoItemsLabel);
                            if (form.completePromoItems === '0') {
                                $('.js-completeYourPromo-header_remaining').addClass('cc-cartPromotionModal-footer_completed');
                            }
                            $('.js-cartPromotionModal-footer_active').next('.cc-cartPromotionModal-footer-tracker_item').addClass('cc-cartPromotionModal-footer-tracker_item_active js-cartPromotionModal-footer_active');
                        }
                        $('body').trigger('product:afterAddToCart', { ...data, form, $productContainer });
                        $('body').trigger('count:update', data);

                        if (data.error) {
                            return;
                        }
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        if ($('.page[data-action="Cart-Show"]').length > 0) {
                            if (history.scrollRestoration) {
                                history.scrollRestoration = 'manual';
                            }
                        }
                        if ($target.closest('.js-complete-your-promo').length > 0) {
                            $target.closest('.js-prodTile').find('.js-added-text').removeClass('hidden').addClass('cc-cartPromotionModal-productCards-body-confirmation');
                            $target.closest('.js-prodTile').parents('.cc-cartPromotionModal-productCards-product').addClass('cc-cartPromotionModal-productCards-product_active');
                            $target.closest('.js-prodTile').find('.cc-intProductDetail-colors-heading').hide();
                            $target.closest('.js-prodTile').find('.js-added-quantity').removeClass('hidden');
                            $target.parent().hide();
                            if ($target.closest('.js-wishlist-items-container').length > 0) {
                                let $item = $target.closest('.js-cross-product').clone();
                                if ($('.js-items-container .js-cross-product').length > 0) {
                                    $('.js-items-container .js-cross-product').first().before($item);
                                } else {
                                    $('.js-items-container').append($item);
                                }
                                $target.closest('.js-cross-product').remove();
                                if ($('.js-wishlist-items-container .js-cross-product').length === 0) {
                                    $('.js-wishlist-items-container').hide();
                                }
                            }
                        } else {
                            location.reload();
                        }
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    }
    addAnotherProduct () {
        $('body').on('click', '.cart-page .js-add-another-to-cart', function (e) {
            e.preventDefault();
            const $productContainer = $(this).closest('.product-info');
            const analytics = $productContainer.find('.analytics.checkout.checkout-product').data();

            const url = $(e.currentTarget).data('action');
            const form = {
                pid: $(e.currentTarget).data('pid'),
                quantity: 1,
                pidsObj: {},
                childProducts: [],
                GTMItemListName: analytics.item_list_name,
                GTMItemListId: analytics.item_list_id,
                GTMIndex: analytics.index
            };

            // Add another personalized product
            if ($(e.currentTarget).data('uniqueidentifier')) {
                form.uniqueIdentifierPers = $(e.currentTarget).data('uniqueidentifier');
                form.uniqueIdentifierNew = Math.random();
            }

            $.spinner().start();
            $.ajax({
                url: url,
                data: form,
                type: 'post',
                dataType: 'json',
                success: function (data) {
                    $('body').trigger('product:afterAddToCart', { ...data, form, $productContainer });
                    $('body').trigger('count:update', data);
                    location.reload();
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        console.log(err.responseJSON.errorMessage);
                    }
                    $.spinner().stop();
                },
            });
        });
    }

    editProduct () {
        $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', e => {
            e.preventDefault();

            let clickedProductId = $(e.target).closest('.cart-line-item').find('.analytics.checkout-product').data('item_sfcc');
            if (clickedProductId) {
                try {
                    localStorage.setItem('clickedProductEdit', clickedProductId);
                } catch (e) {}
            }

            $.spinner().start();
            // modal options
            var modalOptions = {
                footer: false,
                closeMethods: ['overlay', 'button', 'escape'],
                closeLabel: '<svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"> <path d="M12,11.3L22.3,1L23,1.7L12.7,12L23,22.3L22.3,23L12,12.7L1.7,23L1,22.3L11.3,12L1,1.7L1.7,1C1.7,1,12,11.3,12,11.3z"/></svg>',
                cssClass: ['quickview-modal'],
                onClose: () => {
                    $('.carousel-inner, .slick-initialized:not(.suggested-products-slider)').slick('unslick');
                    modal.destroy();
                },
                beforeClose: () => {
                    if ($('.tingle-modal.tingle-modal--visible').length < 2) {
                        $('html').removeClass('html-tingle-enabled');
                    }
                    return true;
                }
            };
            const modal = newModalWithOptions(modalOptions);
            this.currentlyOpenedModal = modal;

            $.ajax({
                url: $(e.currentTarget).attr('href'),
                method: 'GET',
                dataType: 'json',
                success: rsp => {
                    modal.setContent(rsp.renderedTemplate);
                    // Move close button inside modal content box
                    moveModalCloseButton();
                    showAllColorsButton();
                    $('.quickview-modal').addClass('quickview-modal--intimissimi');
                    $(modal.modalBox).addClass('rightModalAttribute');
                    modal.open();
                    $('html').addClass('html-tingle-enabled');
                    // Slick carousel
                    $('.carousel-inner').slick({
                        dots: false,
                        arrows: false,
                        slidesToShow: 2.35,
                        infinite: false,
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 1023,
                                settings: {
                                    slidesToShow: 2.5
                                }
                            }]
                    });
                    productSlider();
                    $.spinner().stop();

                    $(modal.modalBox).on('click', '.close-custom', function () {
                        modal.close();
                        modal.destroy();
                    });
                    $(modal.modalBox).on('click', '.js-close-select-size', function () {
                        let modal = $('.js-modal-quick-size-quantity');
                        modal.addClass('hidden').removeClass('open');
                    });
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });
    }

    removeBonusProduct () {
        $('.bonus-product-remove-btn').on('click', function (e) {
            var bonusProductIdRemoveAction = $(e.currentTarget).data('action');

            $.ajax({
                url: bonusProductIdRemoveAction,
                method: 'GET',
                dataType: 'json',
                success: () => {
                    // TODO: handle feedback on page
                    location.reload();
                },
                error: () => {
                    // TODO: handle feedback on page
                }
            });
        });
    }

    promoCode () {
        $('.promo-code-form').submit(function (e) {
            e.preventDefault();
            $.spinner().start();

            // Reset state
            var $form = $('.promo-code-form');
            $('.coupon-code-field').removeClass('is-invalid');
            $('.coupon-error-message').empty();
            $('.js-couponError-icon').hide();
            $('.coupon-error-message').addClass('hide');
            $('.coupon-error-message-icon').addClass('hide');
            $('.coupon-missing-error').addClass('hidden');
            $('.promocode.error-message').addClass('hidden');
            $('.js-applied-coupon-message').addClass('hide');

            // if the user did not insert any promocode
            if (!$('.coupon-code-field').val()) {
                $('.coupon-code-field').addClass('is-invalid');
                $('.promocode.error-message').removeClass('hidden');
                $('.coupon-missing-error').removeClass('hidden');
                $.spinner().stop();
                return false;
            }

            $.ajax({
                url: $form.attr('action'),
                type: 'GET',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (data.error) {
                        $('body').trigger('cart:afterCouponApply', { code: '', uuid: '', btnAction: 'apply' });
                        $('.promocode.error-message').show();
                        $('.coupon-code-field').addClass('is-invalid');
                        $('.js-couponError-icon').show();
                        $('.coupon-error-message').empty().append(data.errorMessage);
                        $('.coupon-error-message').removeClass('hide');
                        $('.coupon-error-message-icon').removeClass('hide');
                    } else {
                        // Find the promocode applied just now
                        let uuid, couponcode;
                        for (let i = 0; i < data.totals.discounts.length; i++) {
                            let currentDiscount = data.totals.discounts[i];
                            if (currentDiscount.type === 'coupon') {
                                uuid = currentDiscount.UUID;
                                couponcode = currentDiscount.couponCode;
                                break;
                            }
                        }
                        $('body').trigger('cart:afterCouponApply', { code: couponcode, uuid: uuid, btnAction: 'apply' });

                        // if the promocode has been successfully added, we have
                        // to disable the input field and change the button
                        // to Remove
                        $('.coupon-code-field')
                            .prop('disabled', true)
                            .addClass('coupon-code-field--applied');
                        $('.input-group-icon').addClass('input-group-icon--applied');
                        $('.js-coupon-tick').removeClass('hide');
                        // Fix the FE for the ADD / REMOVE buttons
                        $('.js-promocode-remove-btn')
                            .removeClass('hidden')
                            .data('uuid', uuid)
                            .data('code', couponcode);
                        $('.js-promocode-add-btn').addClass('hidden');

                        // Update the FE with the new totals
                        cart.updateCartTotals(data);
                        cart.updateApproachingDiscounts(data.approachingDiscounts);
                        cart.updateReachedDiscounts(data.appliedShippingDiscounts);
                        cart.validateBasket(data);
                        summaryHelpers.updateTotals(data.totals);

                        // Disable loyalty coupon
                        $('.loyalty-coupons-container').addClass('disabled');

                        // Show checkout message of applied coupons
                        if (data.coupon && data.coupon.message) {
                            $('.js-applied-coupon-amount').text(data.coupon.message.promoCodeAmount);
                            $('.js-applied-coupon-total').text(data.coupon.message.totalOrder);
                            $('.js-applied-coupon-message').removeClass('hide');
                        }

                        window.location.reload();
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    $('body').trigger('cart:afterCouponApply', { code: '', uuid: '', btnAction: 'apply' });
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
            return false;
        });
    }

    removeLoyaltyCouponFromCart () {
        $('body').on('click', '.js-remove-loyalty-coupon', function (e) {
            e.preventDefault();
            const data = {
                actionUrl: $(e.currentTarget).data('action'),
                couponCode: $(e.currentTarget).data('code'),
                uuid: $(e.currentTarget).data('uuid')
            };
            confirmRemovePromoCode(data, false);
        });
    }

    removePromoCode () {
        $('body').on('click', '.remove-coupon', function (e) {
            e.preventDefault();
            const data = {
                actionUrl: document.getElementById('removeCouponModal').getAttribute('data-action'),
                couponCode: $(e.currentTarget).data('code'),
                uuid: $(e.currentTarget).data('uuid')
            };
            confirmRemovePromoCode(data);
        });
    }

    updateAddToCart () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('button.update-cart-product-global').prop('disabled',
                !response.product.available || response.product.comingSoon || response.product.isSizeInexistent);

            $('.update-cart-product-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order') ||
                !$('.global-availability', dialog).data('available')
            );
        });
    }

    updateAvailability () {
        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .removeClass('availability-msg--lowstock availability-msg--available availability-msg--comingsoon')
                .empty()
                .html(response.message);

            if (response.product.available) {
                if (response.product.availability.lowStockItems) {
                    $('.product-availability', response.$productContainer)
                        .find('.availability-msg')
                        .addClass('availability-msg--lowstock');
                } else {
                    $('.product-availability', response.$productContainer)
                        .data('ready-to-order', response.product.readyToOrder)
                        .data('available', response.product.available)
                        .find('.availability-msg')
                        .addClass('availability-msg--available');
                }
            } else if (response.product.comingSoon) {
                $('.product-availability', response.$productContainer)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .addClass('availability-msg--comingsoon');
            }

            var dialog = $(response.$productContainer);
            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                // $('.global-availability .availability-msg', dialog).empty()
                // .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available);
                // .find('.availability-msg')
                // .empty()
                // .html(response.message);
                if (response.product.available) {
                    $('.global-availability', dialog)
                        .data('ready-to-order', response.product.readyToOrder)
                        .data('available', response.product.available);
                    // .find('.availability-msg')
                    // .addClass('text-brand-green')
                    // .removeClass('text-medium-gray');
                }
            }
        });
    }

    afterAttributeSelect () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview .bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
            } else {
                // $('.modal.show .product-quickview').data('pid', response.data.product.id);
                // $('.update-cart-product-global').data('pid', response.data.product.id);
                $('.quickview-modal').find('.product-quickview').data('pid', response.data.product.id);
            }

            if (response.type === 'color') {
                if ($(response.container).hasClass('product-freegift')) {
                    response.data.product.isFreeGist = true;
                }
                $('body').trigger('product:didChangeColorForProductDetails', response.data.product);
            }
        });
    }

    updateCartProductGlobal () {
        $('body').on('click', '.update-cart-product-global', e => {
            e.preventDefault();
            var isQuickView = $(e.currentTarget).closest('.quickview-modal').length > 0;
            if ($(e.currentTarget).data('disabled') && !isQuickView) {
                // If no size is selected, open modal to choose one
                if ($(e.currentTarget).closest('.quickview-modal').length) {
                    // QuickView (Open the other modal type)
                    let modal = $('.js-modal-quick-size-quantity');
                    // First check if it is open
                    if (!modal.hasClass('open')) {
                        modal.removeClass('hidden').addClass('open');
                        modal.find('.slick-slider.slick-initialized').slick('refresh');
                    }
                }
                $(e.currentTarget).data('disabled', false);
                return;
            } else if (isQuickView) {
                $(e.currentTarget).data('disabled', false);
            }

            var updateProductUrl = $(e.currentTarget).closest('.cart-and-ipay').find('.update-cart-url').val();
            var selectedQuantity = $(e.currentTarget).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
            var uuid = $(e.currentTarget).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');
            var size = $('.boolean-field.swatch-boolean.dark input:checked').attr('id');
            var sku = $('.quickview-modal').find('.product-quickview').attr('data-variant-pid');
            var skuSplit = sku.split('_');
            if (size && skuSplit.length > 1) {
                if (skuSplit[2].length > 3) {
                    sku = skuSplit[0] + '   ' + skuSplit[2] + size;
                } else {
                    sku = skuSplit[0] + '   ' + skuSplit[2] + ' ' + size;
                }
            }

            if (isQuickView && $('.js-quick-quantity').length > 0) {
                let quantity = parseInt($('.js-quick-quantity').val());
                selectedQuantity = quantity;
            }

            var form = {
                uuid: uuid,
                pid: decodeURI(sku),
                quantity: selectedQuantity
            };

            // TODO: check if still used
            const isGiftCardProduct = $(e.currentTarget).data('giftcard');
            if (isGiftCardProduct) {
                // Validate price
                let amountSelectorOk = true;
                if ($('.js-amount-selector.active').length === 0 || $('.js-amount-selector.active').data('amount') === 0) {
                    $('.js-price-validation-error-not-selected').removeClass('hidden');
                    amountSelectorOk = false;
                }

                let errors = [];
                let container = $('.parsleyValidatableElement');
                for (let i = 0; i < container.length; i++) {
                    let validator = container.eq(i).parsley();
                    validator.validate();
                    if (!validator.isValid()) {
                        errors.push(validator);
                    }
                }

                if (errors.length > 0 || !amountSelectorOk) {
                    return;
                }

                let pid = ProductHelpers.methods.getPidValue($(e.currentTarget));
                uuid = $(e.currentTarget).data('uid');

                let country = $('#countrySelector').val();
                let destinationName = $('.js-giftcardNameTo').val();
                let destinationMail = $('#giftcard--mail-to').val();
                let senderName = $('.js-giftcardYourName').val();
                let message = $('#contact-form-message').val();
                let amount = $('.js-amount-selector.active').attr('data-amount');

                let dateString = $('.datepickerTriggerElement').data('date');
                if (dateString.match(/-/g).length !== 2) {
                    dateString = formatDate(new Date(dateString));
                }

                let imgUrl = $('.js-giftcard-swatch.slick-current img').attr('src');
                let imgCodes = imgUrl.split('/');
                let imgCode = imgCodes[imgCodes.length - 1].replace('.jpg', '');

                form = {
                    pid: pid,
                    quantity: 1,
                    uuid: uuid,
                    destinationName: destinationName,
                    destinationMail: destinationMail,
                    message: message,
                    senderName: senderName,
                    amount: amount,
                    shippingDate: dateString,
                    country: country,
                    imageCode: imgCode,
                    imgUrl: imgUrl
                };
            }

            $.spinner().start();
            if (updateProductUrl) {
                $.ajax({
                    url: updateProductUrl,
                    type: 'post',
                    context: this,
                    data: form,
                    dataType: 'json',
                    success: function (data) {
                        this.currentlyOpenedModal.close();

                        $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                        $('.promos').empty().append(data.cartModel.totals.promocodesHtml);
                        cart.updateCartTotals(data.cartModel, data.loyalty);
                        cart.updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                        cart.updateReachedDiscounts(data.cartModel.appliedShippingDiscounts);
                        updateAvailability(data.cartModel, uuid);

                        if (isGiftCardProduct) {
                            updateGiftCardDetails(data, uuid);
                        } else {
                            updateProductDetails(data, uuid);
                        }

                        if (data.uuidToBeDeleted) {
                            $('.uuid-' + data.uuidToBeDeleted).remove();
                        }

                        cart.validateBasket(data.cartModel);

                        var $productContainer = $(e.currentTarget).closest('.product-detail');

                        if (!$productContainer.length) {
                            $productContainer = $(e.currentTarget).closest('.quickview-modal').find('.product-detail');
                        }

                        if (!$productContainer.length) {
                            $productContainer = $('.quickview-modal').find('.product-detail');
                        }

                        if (!$productContainer.length) {
                            $productContainer = $('.product-detail');
                        }

                        // For analytics after add quantity to cart
                        $('body').trigger('product:addQuantityFromCart', {
                            ...data,
                            form,
                            $productContainer
                        });

                        location.reload();

                        // $.spinner().stop();
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification(err.responseJSON.errorMessage);
                            $.spinner().stop();
                        }
                    }
                });
            }
        });

        $('body').on('click', '.addTocartSaveForLater', e => {
            var $productContainer = $(e.currentTarget).closest('.product-save-for-later.product-detail');
            var pid = $(e.currentTarget).data('pid');
            var form = {
                pid: pid,
                quantity: 1
            };
            var addToCartUrl = $('.add-to-cart-url').val();

            $.spinner().start();
            $(e.currentTarget).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: data => {
                        if (data.error) {
                            $('.content-input-err').removeClass('hidden');
                            $.spinner().stop();
                        } else {
                            handleRemoveSaveForlater(form);
                            data.quantityTotal = data.cart ? data.cart.numItems : data.cartModel.numItems;
                            handlePostCartAdd(data);

                            $('body').trigger('product:afterAddFromSaveForLater', {
                                ...data,
                                form,
                                $productContainer
                            });

                            if ($('.page').data('action') === 'Cart-Show') {
                                window.location.reload();
                            }
                        }
                    },
                    error: () => {
                        $.spinner().stop();
                    }
                });
            }
        });

        $('body').on('click', '.add-size-saveForLater', e => {
            var oldSku = $(e.currentTarget).attr('data-sku-old');
            var sku = $(e.currentTarget).attr('data-sku');
            var form = {
                oldSku: oldSku,
                sku: sku
            };
            var addToCartUrl = $('.editSaveForLater').val();

            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: data => {
                        $.spinner().stop();
                        if (data.error) {
                            $('.content-input-err').removeClass('hidden');
                        } else {
                            if ($('.page').data('action') === 'Cart-Show') {
                                window.location.reload();
                            }
                        }
                    },
                    error: () => {
                        $.spinner().stop();
                    }
                });
            }
        });
        $('body').on('click', '.js-open-modal-size', e => {
            var pid = $(e.currentTarget).data('pid');

            var htmlContent = $("#fis-select-size[data-pid='" + pid + "']").html();
            // * * Create and open modal
            var modal = newModalFromString(htmlContent, false);
            modal.open();
        });

        $('body').on('click', '.js-open-modal-color', e => {
            var htmlContent = $('#fis-select-color').html();
            // * * Create and open modal
            var modal = newModalFromString(htmlContent, false);
            modal.open();
        });

        $('body').on('click', '.remove-saveForLater', e => {
            var url = $('.removeSaveForLater').val();
            var pid = $(e.currentTarget).data('pid');
            var form = {
                pid: pid,
                quantity: 1
            };
            $.ajax({
                url: url,
                method: 'POST',
                data: form,
                success: function (html) {
                    location.reload();
                },
                error: function () {
                }
            });
        });

        const handlePostCartAdd = response => {
            $('body').trigger('count:update', response);
            // show add to cart toast
            if (response.error) {
                return;
            }
            if ($('.add-to-cart-messages').length === 0) {
                $('.minicart').append(
                    '<div class="add-to-cart-messages"></div>'
                );
            }
        };

        const handleRemoveSaveForlater = response => {
            var url = $('.removeSaveForLater').val();
            $.ajax({
                url: url,
                method: 'POST',
                data: response,
                success: function (html) {
                },
                error: function () {
                }
            });
        };
    }

    /**
     * re-renders the order totals and the number of items in the cart
     * @param {Object} data - AJAX response from the server
    */
    updateCartTotals (cartModel, loyaltyData) {
        // Notify Bambuser player (in parent frame) that the cart changed
        try {
            var targetWindow = window.parent !== window ? window.parent : window;
            targetWindow.postMessage({ type: 'bambuser:cartChanged' }, '*');
        } catch (e) { /* cross-origin or unavailable — ignore */ }

        $('.number-of-items').empty().append(cartModel.resources.numberOfItems);
        $('.shipping-total-cost').empty().append(cartModel.totals.totalShippingCost);
        $('.shipping-discount-total').empty().append(cartModel.totals.shippingLevelDiscountTotal);
        $('.tax-total').empty().append(cartModel.totals.totalTax);
        $('.grand-total-sum').empty().append(cartModel.totals.grandTotal);
        $('.analytics-totals').data('grandTotal', (cartModel.totals.grandTotalValue || 0).toFixed(2));
        if ('thereIsPers' in cartModel.totals && cartModel.totals.thereIsPers) {
            $('.full-cost').empty().append(cartModel.totals.fullTotalNoPers);
            $('.personalization-row').removeClass('hide');
            $('.personalization-full-total').text(cartModel.totals.persTotal);
        } else {
            $('.personalization-row').addClass('hide');
            $('.full-cost').empty().append(cartModel.totals.fullTotal);
        }
        $('.js-mainHeader-counter_minicart').empty().append(cartModel.numItems);

        if (cartModel.totals.productLevelDiscountTotal.value > 0) {
            $('.product-discount').removeClass('hide');
            $('.product-discount-total').empty().append('- ' + cartModel.totals.productLevelDiscountTotal.formatted);
        } else {
            $('.product-discount').addClass('hide');
        }

        if (cartModel.totals.orderLevelDiscountTotal.value > 0) {
            $('.order-discount').removeClass('hide');
            $('.order-discount-total').empty().append('- ' + cartModel.totals.orderLevelDiscountTotal.formatted);
        } else {
            $('.order-discount').addClass('hide');
        }

        if (cartModel.totals.shippingLevelDiscountTotal.value > 0) {
            $('.shipping-discount').removeClass('hide');
            $('.shipping-discount-total').empty().append('- ' +
                cartModel.totals.shippingLevelDiscountTotal.formatted);
        } else {
            $('.shipping-discount').addClass('hide');
        }

        if (cartModel.totals.codTotalPrice) {
            $('.cod-item').removeClass('hide-cod-item');
            $('.cod-total-cost').empty().append(cartModel.totals.codTotalPrice);
        } else {
            $('.cod-item').addClass('hide-cod-item');
        }

        if ('totalPoints' in cartModel.totals && cartModel.totals.totalPoints) {
            if (loyaltyData && 'loyaltyLabel' in loyaltyData && loyaltyData.loyaltyLabel) {
                $('.loyalty-points-cart-message').html(loyaltyData.loyaltyLabel);
            } else {
                $('.estimated-loyalty-points').text(cartModel.totals.totalPoints);
            }
        }

        cartModel.items.forEach(function (item) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        });
    }

    /**
     * re-renders the approaching discount messages
     * @param {Object} approachingDiscounts - updated approaching discounts for the cart
    */
    updateApproachingDiscounts (approachingDiscounts) {
        var html = '';
        $('.approaching-discounts').empty();
        if (approachingDiscounts.length > 0) {
            let template = $('#approachingDiscountTemplate').clone();
            approachingDiscounts.forEach(function (item) {
                $('.content', template).html(item.plainDiscountMsg);
                html += $(template).html();
            });
        }
        $('.approaching-discounts').append(html);
    }

    /**
     * re-renders the reached discounts
     * @param {Object[]} reachedDiscounts - reached discounts for the updated cart
    */
    updateReachedDiscounts (reachedDiscounts) {
        let html = '';
        let overrideMsg = true;
        if (reachedDiscounts.length > 0) {
            if (('.js-fixed-reached-discount-msg').length) overrideMsg = false;
            let template = $('#reachedDiscountTemplate').clone();
            if ($('#reachedDiscountTemplate .content').length) {
                reachedDiscounts.forEach(function (item) {
                    if (item.plainDiscountMsg) {
                        $('.content', template).html(item.plainDiscountMsg);
                    } else {
                        $('.content', template).html(item);
                    }
                    html += $(template).html();
                });
            }
        }
        if (overrideMsg) $('.reached-discounts').empty().append(html);
    }

    /**
     * Checks whether the basket is valid. if invalid displays error message and disables
     * checkout button
     * @param {Object} data - AJAX response from the server
    */

    validateBasket (data) {
        if (data.valid.error) {
            if (data.valid.message) {
                if (!$('.cart-alert')) {
                    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                    'fade show" role="alert">' +
                    '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                    '<span aria-hidden="true">&times;</span>' +
                    '</button>' + data.valid.message + '</div>';
                    $('.cart-error').append(errorHtml);
                }
            } else {
                $('.cart').empty().append('<div class="row"> ' +
                    '<div class="col-12 text-center"> ' +
                    '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                    '</div> ' +
                    '</div>'
                );
                $('.number-of-items').empty().append(data.resources.numberOfItems);
                $('.js-mainHeader-counter_minicart').empty().append(data.numItems);
                $('.js-mainHeader-minicart .popover').empty();
                $('.js-mainHeader-minicart .popover').removeClass('show');
            }

            $('.checkout-btn').prop('disabled', true);
            $('.js-paypal-container').addClass('disabled');
            $('.js-amazon-pay-container').addClass('disabled');
            $('.js-google-pay-container').addClass('disabled');
        } else {
            $('.checkout-btn').prop('disabled', false);
            $('.cart-alert').remove();
        }
    }

    shippingRecap () {
        $('body').on('click', '.shipping-methods-recap', () => {
            var modal = newModalFromSelector('methods-recap-modal-content');
            $(modal.modalBox).addClass('shipping-methods-info');
            modal.open();

            $(modal.modalBox).find('.recap-methods-close, .modal-close').on('click', () => {
                modal.close();
                modal.destroy();
            });
        });

        $('body').on('click', '.check-dispo-availability', function (e) {
            var url = $(e.currentTarget).data('url');
            var storeID = $('#storeId').val();
            var currentHour = (new Date()).getHours();
            $.spinner().start();

            $.ajax({
                url: url,
                data: {
                    storeID: storeID,
                    currentHour: currentHour
                },
                type: 'post',
                success: data => {
                    $.spinner().stop();
                    if (data.getArrivalHour) {
                        // $('.arrival-hour').html(data.getArrivalHour);
                        $('.dispo-availability-response').removeClass('hide');
                        $('.dispo-is-not-available-text').addClass('hide');
                        $('.dispo-is-available-text').removeClass('hide');
                        var pickupTimeLabel = data.isTomorrow ? data.tomorrowPickUpTimeLabel : data.pickUpTimeLabel;
                        $('.js-recap-type-delivery-interval').text(pickupTimeLabel);
                        $('.js-recap-type-delivery-method').hide();
                    } else {
                        $('.dispo-availability-response').removeClass('hide');
                        $('.dispo-is-available-text').addClass('hide');
                        $('.dispo-is-not-available-text').removeClass('hide');
                        $('.search-another-store-dispo').removeClass('hide');
                        $('.find-in-store-wrapper').html(data.findInStoreSummary);
                        $('.js-recap-type-delivery-interval').text($('#formattedArrivalInterval').val());
                        $('.js-recap-type-delivery-method').show();
                        FindInStore.run(false);
                    }
                    $('.check-dispo-availability').addClass('hidden');
                    $('.cc-shipping-container-content_checkDispoAvailability').addClass('hidden');
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }

    mobileOpenCheckoutCTA () {
        $('body').on('click', '.fake-checkout-btn-mobile', (e) => {
            e.preventDefault();
            const unavailableProducts = $('#removeUnavailableItemsModal').data('unavailable-skus');
            const hasUnavailableItems = unavailableProducts && unavailableProducts.length > 0;
            if (unavailableProducts && unavailableProducts.length > 0 && hasUnavailableItems) {
                removeAllUnavailableLineItems();
            } else {
                $('#checkout-button-secure-checkout').trigger('click');
            }
        });
    }

    openTooltip () {
        $(document).on('mouseenter focusin', '.one-line-text .info-icon', function (e) {
            if (Foundation.MediaQuery.atLeast('medium')) {
                $('.tooltip.hide-for-small-only').addClass('make-visible');
            }
        }).on('mouseleave focusout', '.one-line-text .info-icon', function (e) {
            $('.tooltip.hide-for-small-only.make-visible').removeClass('make-visible');
        });
        $(document).on('mouseenter focusin', '.recap-estimated-arrival .info-icon', function (e) {
            if (!Foundation.MediaQuery.atLeast('large')) {
                $('.tooltip.recap-eta').css({left: $('.js-shipping').offset().left - $('.info-icon.recap-eta').offset().left + 24});
            }
        });
    }

    triggerExpressModal () {
        if ($('#personalizationRemoved').val() === 'paypal') {
            $('.js-ModalExpressButton-paypal').trigger('click');
        }
        if ($('#personalizationRemoved').val() === 'klarna') {
            $('.js-ModalExpressButton-klarna').trigger('click');
        }
        if ($('#personalizationRemoved').val() === 'amazon') {
            $('.js-ModalExpressButton-amazonPay').trigger('click');
        }
        var url = window.location.href;
        var urlWithNoQuery = url.split('?')[0];
        history.replaceState(null, null, urlWithNoQuery);
    }
}

const cart = new Cart();
export default cart;
